import React from "react";
import { MenuItem, Select, Stack, Typography } from "@mui/material";

import { getOmittedStatusChoices } from "../../../services/priceHistoryOmitted";
import { OMISSION_REASON_CHOICES, formatOmissionCodeLabel } from "./omissionReasons";

const SORT_OPTIONS = [
  { value: "created_desc", label: "Created (newest)" },
  { value: "created_asc", label: "Created (oldest)" },
  { value: "retailer_asc", label: "Retailer (A-Z)" },
  { value: "retailer_desc", label: "Retailer (Z-A)" },
  { value: "product_asc", label: "Product (A-Z)" },
  { value: "product_desc", label: "Product (Z-A)" },
];

const formatStatusLabel = (value) => {
  if (!value || typeof value !== "string") return value;
  return value
    .split("_")
    .map((part) => `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
    .join(" ");
};

const PriceHistoryOmittedToolbar = ({
  status,
  onStatusChange,
  code,
  onCodeChange,
  sortBy,
  onSortChange,
}) => (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }} alignItems="center" flexWrap="wrap">
    <Typography sx={{ fontSize: "0.8rem" }}>Status:</Typography>
    <Select
      size="small"
      value={status}
      onChange={(event) => {
        onStatusChange(event.target.value);
      }}
    >
      <MenuItem value="all">All</MenuItem>
      {getOmittedStatusChoices().map((value) => (
        <MenuItem key={value} value={value}>
          {formatStatusLabel(value)}
        </MenuItem>
      ))}
    </Select>

    <Typography sx={{ fontSize: "0.8rem", ml: 1 }}>Reason:</Typography>
    <Select
      size="small"
      value={code}
      onChange={(event) => {
        onCodeChange(event.target.value);
      }}
      sx={{ minWidth: 200 }}
    >
      <MenuItem value="all">All</MenuItem>
      {OMISSION_REASON_CHOICES.map((entry) => (
        <MenuItem key={entry.code} value={entry.code}>
          {entry.label || formatOmissionCodeLabel(entry.code)}
        </MenuItem>
      ))}
    </Select>

    <Typography sx={{ fontSize: "0.8rem", ml: 1 }}>Sort:</Typography>
    <Select
      size="small"
      value={sortBy}
      onChange={(event) => {
        onSortChange(event.target.value);
      }}
    >
      {SORT_OPTIONS.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  </Stack>
);

export default PriceHistoryOmittedToolbar;
